



































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { AccountAdvEditModel } from '@/services/api/nswag/stapiclient_generated';
import { stAccountApi } from '@/services/st-api';

@Component({
  components: {},
})
export default class AdvContract extends Vue {
  editModel: AccountAdvEditModel = AccountAdvEditModel.fromJS({});

  async mounted() {
    await this.loadData();
  }

  async loadData() {
    this.editModel = await stAccountApi.getAdvEditModel();
  }
}
